
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi faire un audit SEO régulier et comment le réussir",
    description:
      "Découvrez pourquoi un audit SEO régulier est essentiel pour votre visibilité en ligne et comment le mettre en place étape par étape. Suivez nos conseils d'expert !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
